import moment from 'moment'

export default function (audioFileDownloadedAt) {
  if (audioFileDownloadedAt) {
    return `Audio file downloaded at ${moment.utc(audioFileDownloadedAt).local().format('h:mm:ss A')} on ${moment.utc(audioFileDownloadedAt).local().format('M/D/YYYY')}.`
  } else {
    return `The audio file has not been downloaded.`
  }
}
